import {
    config,
    requestOptions,
    requestTypes,
    sendRequest,
} from "../../../Utilities/Api";

//************************************************** STANDARD API SERVER CALLS ****************************************

class serverBraillerPackingListApi {

    static getBraillerLoanItem(braillerLoanId: string) {
        return sendRequest(
            requestOptions(config.URL + `braillers/loans/${braillerLoanId}/`,
                requestTypes.GET,
            ),
        );
    }
}

export const braillerPackingListApi = config.environment.MODE === config.modes.SERVER ? serverBraillerPackingListApi : serverBraillerPackingListApi;
